import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=11d7b71c&scoped=true"
import script from "./ClientSearch.vue?vue&type=script&lang=ts"
export * from "./ClientSearch.vue?vue&type=script&lang=ts"
import style0 from "./ClientSearch.vue?vue&type=style&index=0&id=11d7b71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d7b71c",
  null
  
)

export default component.exports